import palette from "../palette";

export default {
  root: {
    padding: "6px 4px 6px 4px",
    border: `1px solid ${palette.tableCellDivider}`,
  },
  head: {
    padding: "6px 4px 6px 4px",
    backgroundColor: palette.background.header,
    border: `1px solid ${palette.tableCellDivider}`,
  },
  sizeSmall: {
    padding: "6px 4px 6px 4px",
    border: `1px solid ${palette.tableCellDivider}`,
    "&:last-child": {
      padding: "6px 4px 6px 4px",
      paddingRight: "0px"
    }
  },
  body: {
    border: `1px solid ${palette.tableCellDivider}`,
  },
  footer: {
    border: `1px solid ${palette.tableCellDivider}`,
    backgroundColor: palette.background.footer,
  },
  paddingCheckbox: {
    border: `1px solid ${palette.tableCellDivider}`,
  },
  paddingNone: {
    border: `1px solid ${palette.tableCellDivider}`,
  },
  alignLeft: {
    border: `1px solid ${palette.tableCellDivider}`,
  },
  alignCenter: {
    border: `1px solid ${palette.tableCellDivider}`,
  },
  alignRight: {
    border: `1px solid ${palette.tableCellDivider}`,
  },
  alignJustify: {
    border: `1px solid ${palette.tableCellDivider}`,
  },
  stickyHeader: {
    border: `1px solid ${palette.tableCellDivider}`,
  },
};
